{
  "button_add_more_images": [
    {
      "type": 0,
      "value": "Añadir más imágenes"
    }
  ],
  "button_approve": [
    {
      "type": 0,
      "value": "Aprobar"
    }
  ],
  "button_back": [
    {
      "type": 0,
      "value": "Volver"
    }
  ],
  "button_back_to_cart": [
    {
      "type": 0,
      "value": "Gallery"
    }
  ],
  "button_back_to_login": [
    {
      "type": 0,
      "value": "Volver al inicio de sesión"
    }
  ],
  "button_bill_to_room": [
    {
      "type": 0,
      "value": "Facturar a la habitación"
    }
  ],
  "button_buy_more": [
    {
      "type": 0,
      "value": "Comprar más"
    }
  ],
  "button_cancel": [
    {
      "type": 0,
      "value": "Cancelar"
    }
  ],
  "button_close": [
    {
      "type": 0,
      "value": "Cerrar"
    }
  ],
  "button_complete_purchase": [
    {
      "type": 0,
      "value": "Finalizar compra"
    }
  ],
  "button_continue": [
    {
      "type": 0,
      "value": "Continuar"
    }
  ],
  "button_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Tarjeta de crédito o débito"
    }
  ],
  "button_customer_login": [
    {
      "type": 0,
      "value": "Back to Customer Login"
    }
  ],
  "button_done": [
    {
      "type": 0,
      "value": "HECHO"
    }
  ],
  "button_download": [
    {
      "type": 0,
      "value": "Descargar"
    }
  ],
  "button_edit_order": [
    {
      "type": 0,
      "value": "Modificar pedido"
    }
  ],
  "button_enter": [
    {
      "type": 0,
      "value": "Entrar"
    }
  ],
  "button_forgot": [
    {
      "type": 0,
      "value": "Olvidado"
    }
  ],
  "button_got_it": [
    {
      "type": 0,
      "value": "Entendido"
    }
  ],
  "button_image_view_next": [
    {
      "type": 0,
      "value": "Siguiente (flecha derecha)"
    }
  ],
  "button_image_view_previous": [
    {
      "type": 0,
      "value": "Anterior (flecha izquierda)"
    }
  ],
  "button_image_view_zoom": [
    {
      "type": 0,
      "value": "Aumentar/Alejar"
    }
  ],
  "button_log_out": [
    {
      "type": 0,
      "value": "Salir"
    }
  ],
  "button_login": [
    {
      "type": 0,
      "value": "Iniciar sesión"
    }
  ],
  "button_lookup_gallery": [
    {
      "type": 0,
      "value": "Galería de búsqueda"
    }
  ],
  "button_more_images": [
    {
      "type": 0,
      "value": "Más imágenes"
    }
  ],
  "button_new_order": [
    {
      "type": 0,
      "value": "Nuevo pedido"
    }
  ],
  "button_ok": [
    {
      "type": 0,
      "value": "De acuerdo"
    }
  ],
  "button_price_guide": [
    {
      "type": 0,
      "value": "Guía de precios"
    }
  ],
  "button_print": [
    {
      "type": 0,
      "value": "Imprimir"
    }
  ],
  "button_process": [
    {
      "type": 0,
      "value": "Proceso"
    }
  ],
  "button_purchase": [
    {
      "type": 0,
      "value": "Comprar"
    }
  ],
  "button_refresh": [
    {
      "type": 0,
      "value": "Actualizar"
    }
  ],
  "button_remove": [
    {
      "type": 0,
      "value": "Eliminar"
    }
  ],
  "button_remove_prints": [
    {
      "type": 0,
      "value": "Eliminar impresiones"
    }
  ],
  "button_review_and_purchase": [
    {
      "type": 0,
      "value": "Revisar y comprar"
    }
  ],
  "button_review_cart": [
    {
      "type": 0,
      "value": "Cart"
    }
  ],
  "button_select": [
    {
      "type": 0,
      "value": "Seleccionar"
    }
  ],
  "button_selected_print_sizes": [
    {
      "type": 0,
      "value": "Tamaños de impresión seleccionados ("
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "button_send_link": [
    {
      "type": 0,
      "value": "Enviar enlace"
    }
  ],
  "button_send_links": [
    {
      "type": 0,
      "value": "Enviar enlaces"
    }
  ],
  "button_share": [
    {
      "type": 0,
      "value": "Compartir"
    }
  ],
  "button_stay": [
    {
      "type": 0,
      "value": "Quédate"
    }
  ],
  "button_stripe_reader": [
    {
      "type": 0,
      "value": "Lector de banda magnética"
    }
  ],
  "button_tilby": [
    {
      "type": 0,
      "value": "Tilby"
    }
  ],
  "button_toggle_access_codes": [
    {
      "type": 0,
      "value": "Toggle Access Codes"
    }
  ],
  "button_view_gallery": [
    {
      "type": 0,
      "value": "Ver galería"
    }
  ],
  "button_view_my_gallery": [
    {
      "type": 0,
      "value": "Ver mi galería"
    }
  ],
  "button_view_receipt": [
    {
      "type": 0,
      "value": "Ver recibo"
    }
  ],
  "cart_add_image_no_cost": [
    {
      "type": 0,
      "value": "Puedes agregar más imágenes sin costo alguno"
    }
  ],
  "cart_apply_coupon": [
    {
      "type": 0,
      "value": "Aplicar"
    }
  ],
  "cart_buy_all_at_price": [
    {
      "type": 0,
      "value": "Comprar todo El precio es "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "cart_buy_all_discount_description": [
    {
      "type": 0,
      "value": "Comprar todas las imágenes por "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_buy_all_discount_label": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " por todas"
    }
  ],
  "cart_cart_details": [
    {
      "type": 0,
      "value": "Detalles del carrito"
    }
  ],
  "cart_cart_total": [
    {
      "type": 0,
      "value": "Total del carrito"
    }
  ],
  "cart_checkout": [
    {
      "type": 0,
      "value": "Pago"
    }
  ],
  "cart_coupon_code": [
    {
      "type": 0,
      "value": "Código del cupón"
    }
  ],
  "cart_coupon_code_instructions": [
    {
      "type": 0,
      "value": "Please enter your coupon code to apply it to your order."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Click continue to proceed to checkout"
    }
  ],
  "cart_credit_debit_card": [
    {
      "type": 0,
      "value": "Tarjeta de crédito o débito"
    }
  ],
  "cart_digital_image": [
    {
      "type": 0,
      "value": "Imagen digital (s)"
    }
  ],
  "cart_digitals": [
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digital Image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digital Images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_digitals_and_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digital image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digital images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "imageCount"
    },
    {
      "type": 0,
      "value": ", & "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " print"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " prints"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "printCount"
    }
  ],
  "cart_discount_label": [
    {
      "type": 0,
      "value": "Compra más imágenes para obtener un descuento"
    }
  ],
  "cart_image_free_of_charge": [
    {
      "type": 0,
      "value": "Esta "
    },
    {
      "type": 1,
      "value": "imageDesc"
    },
    {
      "type": 0,
      "value": " se ofrecerá de forma gratuita."
    }
  ],
  "cart_link_to_gallery": [
    {
      "type": 0,
      "value": "Se ha enviado un enlace a tu galería a "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "cart_no_photos_available": [
    {
      "type": 0,
      "value": "No images are currently available. If you just had photos taken, they will be available here soon so check back.  If you have not yet had photos taken, please see a photographer to get started"
    }
  ],
  "cart_no_selected_image": [
    {
      "type": 0,
      "value": "Selecciona la/s imagen/es que vas a comprar antes de realizar el pago"
    }
  ],
  "cart_on_date": [
    {
      "type": 0,
      "value": "el "
    },
    {
      "type": 1,
      "value": "date"
    }
  ],
  "cart_packages_discount_description": [
    {
      "type": 0,
      "value": "Obtener "
    },
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " para "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_all": [
    {
      "type": 0,
      "value": "Obtener todas las imágenes de "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_range": [
    {
      "type": 0,
      "value": "Obtener "
    },
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " imágenes por "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label": [
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " por "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label_range": [
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " por "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_price_guide": [
    {
      "type": 0,
      "value": "Guía de precios"
    }
  ],
  "cart_price_guide_notes": [
    {
      "type": 0,
      "value": "Consulta la guía de precios"
    }
  ],
  "cart_prints": [
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Print"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Prints"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_purchase": [
    {
      "type": 0,
      "value": "Comprar"
    }
  ],
  "cart_purchase_unavailable": [
    {
      "type": 0,
      "value": "Mobile purchasing is unavailable.  Please visit the on-site kiosk to view"
    }
  ],
  "cart_purchased": [
    {
      "type": 0,
      "value": "Comprado"
    }
  ],
  "cart_purchasing": [
    {
      "type": 0,
      "value": "Compras"
    }
  ],
  "cart_sorry_charge_problem": [
    {
      "type": 0,
      "value": "Lo sentimos, hemos experimentado un problema que no permitió realizar el cargo. Inténtalo de nuevo y ponte en contacto con nosotros si el problema persiste."
    }
  ],
  "cart_standard_price": [
    {
      "type": 0,
      "value": "El precio estándar es "
    },
    {
      "type": 1,
      "value": "amount"
    },
    {
      "type": 0,
      "value": " cada una"
    }
  ],
  "cart_thank_you_purchase": [
    {
      "type": 0,
      "value": "¡Gracias por tu compra!"
    }
  ],
  "cart_total": [
    {
      "type": 0,
      "value": "Total"
    }
  ],
  "cart_unlock_all": [
    {
      "type": 0,
      "value": "Todas las imágenes digitales"
    }
  ],
  "cart_unlock_all_prints": [
    {
      "type": 0,
      "value": "Todas las imágenes digitales e impresiones"
    }
  ],
  "cart_unpurchased": [
    {
      "type": 0,
      "value": "No comprado"
    }
  ],
  "cart_view_photos": [
    {
      "type": 0,
      "value": "Ver fotos"
    }
  ],
  "cart_volume_discount_description": [
    {
      "type": 0,
      "value": "Compra "
    },
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " y obtén "
    },
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " de descuento"
    }
  ],
  "cart_volume_discount_label": [
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " de descuento por "
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " o más"
    }
  ],
  "consumer_agreement": [
    {
      "type": 0,
      "value": "Al utilizar Capturelife, aceptas nuestro "
    }
  ],
  "consumer_confirm_password": [
    {
      "type": 0,
      "value": "Introduce y confirma tu contraseña."
    }
  ],
  "consumer_confirm_your_password": [
    {
      "type": 0,
      "value": "Confirmación de contraseña"
    }
  ],
  "consumer_contact_us": [
    {
      "type": 0,
      "value": "Ponte en contacto con nosotros"
    }
  ],
  "consumer_email_or_phone": [
    {
      "type": 0,
      "value": "Correo electrónico o teléfono"
    }
  ],
  "consumer_email_or_phone_long": [
    {
      "type": 0,
      "value": "Dirección de correo electrónico o número de teléfono"
    }
  ],
  "consumer_email_placeholder": [
    {
      "type": 0,
      "value": "Correo electrónico"
    }
  ],
  "consumer_enter_email": [
    {
      "type": 0,
      "value": "Introduce una dirección de correo electrónico."
    }
  ],
  "consumer_enter_password": [
    {
      "type": 0,
      "value": "Introduce una contraseña"
    }
  ],
  "consumer_enter_valid_email_phone": [
    {
      "type": 0,
      "value": "Introduce una dirección de correo electrónico o un número de teléfono válidos."
    }
  ],
  "consumer_enter_valid_email_phone_": [
    {
      "type": 0,
      "value": "Introduce una dirección de correo electrónico o un número de teléfono válidos."
    }
  ],
  "consumer_footer_text": [
    {
      "type": 0,
      "value": "El Mundo Mágico y todas las marcas comerciales, personajes, nombres e indicios relacionados son © & ™ Warner Bros. Entertainment Inc. Derechos de publicación © JKR. (s22)"
    }
  ],
  "consumer_forgot_password": [
    {
      "type": 0,
      "value": "Introduce tu dirección de correo electrónico o tu número de teléfono para restablecer tu contraseña"
    }
  ],
  "consumer_forgot_your_password": [
    {
      "type": 0,
      "value": "¿Olvidaste tu contraseña?"
    }
  ],
  "consumer_image_view_print_store": [
    {
      "type": 0,
      "value": "Tienda de impresión"
    }
  ],
  "consumer_item_generate_qr_code": [
    {
      "type": 0,
      "value": "Generar código QR"
    }
  ],
  "consumer_link_expired": [
    {
      "type": 0,
      "value": "Lo sentimos, este enlace ha expirado. Introduce tu correo electrónico o número de teléfono para recibir otro enlace."
    }
  ],
  "consumer_logging_in": [
    {
      "type": 0,
      "value": "Iniciando sesión..."
    }
  ],
  "consumer_logging_in_button": [
    {
      "type": 0,
      "value": "Iniciando sesión..."
    }
  ],
  "consumer_login_message": [
    {
      "type": 0,
      "value": "¡Volvamos a capturar esos momentos!"
    }
  ],
  "consumer_missing_something_error": [
    {
      "type": 0,
      "value": "Vaya, parece que te falta algo."
    }
  ],
  "consumer_my_personal_data": [
    {
      "type": 0,
      "value": "Mis datos personales"
    }
  ],
  "consumer_nav_add_photos": [
    {
      "type": 0,
      "value": "Añadir fotos"
    }
  ],
  "consumer_nav_add_photos_mobile": [
    {
      "type": 0,
      "value": "Añadir"
    }
  ],
  "consumer_nav_back": [
    {
      "type": 0,
      "value": "Volver"
    }
  ],
  "consumer_nav_download": [
    {
      "type": 0,
      "value": "Descargar"
    }
  ],
  "consumer_nav_home": [
    {
      "type": 0,
      "value": "Inicio"
    }
  ],
  "consumer_nav_logout": [
    {
      "type": 0,
      "value": "Cerrar sesión"
    }
  ],
  "consumer_nav_news": [
    {
      "type": 0,
      "value": "Noticias"
    }
  ],
  "consumer_nav_print_store": [
    {
      "type": 0,
      "value": "Tienda de impresión"
    }
  ],
  "consumer_nav_profile": [
    {
      "type": 0,
      "value": "Perfil"
    }
  ],
  "consumer_nav_refresh": [
    {
      "type": 0,
      "value": "Actualizar"
    }
  ],
  "consumer_nav_share": [
    {
      "type": 0,
      "value": "Compartir"
    }
  ],
  "consumer_password_alteast_length": [
    {
      "type": 0,
      "value": "Tu contraseña debe contener al menos "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " caracteres."
    }
  ],
  "consumer_password_placeholder": [
    {
      "type": 0,
      "value": "Contraseña"
    }
  ],
  "consumer_passwords_dont_match": [
    {
      "type": 0,
      "value": "Tu confirmación de contraseña y tu contraseña no coinciden."
    }
  ],
  "consumer_qr_text": [
    {
      "type": 0,
      "value": "Haz una captura de tu Código QR o haz clic en el botón Descargar que aparece a continuación"
    }
  ],
  "consumer_reset_password": [
    {
      "type": 0,
      "value": "Restablecer contraseña"
    }
  ],
  "consumer_resetting_password": [
    {
      "type": 0,
      "value": "Restableciendo contraseña..."
    }
  ],
  "consumer_retake_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_search_photo_button": [
    {
      "type": 0,
      "value": "Search for photos"
    }
  ],
  "consumer_select_all": [
    {
      "type": 0,
      "value": "Seleccionar todo"
    }
  ],
  "consumer_selfie_button": [
    {
      "type": 0,
      "value": "Choose a selfie"
    }
  ],
  "consumer_selfie_instructions": [
    {
      "type": 0,
      "value": "Upload a selfie to get started"
    }
  ],
  "consumer_selfie_upload_complete": [
    {
      "type": 0,
      "value": "Selfie successfully uploaded"
    }
  ],
  "consumer_selfie_upload_failed": [
    {
      "type": 0,
      "value": "An error occurred.  Please try again"
    }
  ],
  "consumer_selfie_upload_in_progress": [
    {
      "type": 0,
      "value": "Upload in progress"
    }
  ],
  "consumer_share_dialog_notes": [
    {
      "type": 0,
      "value": "Para descargar o compartir una imagen, mantén pulsada la imagen para que aparezcan todas las opciones de uso compartido del dispositivo."
    }
  ],
  "consumer_store_title": [
    {
      "type": 0,
      "value": "Tienda en línea"
    }
  ],
  "consumer_take_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_terms_of_use": [
    {
      "type": 0,
      "value": "Condiciones de uso"
    }
  ],
  "consumer_update_email": [
    {
      "type": 0,
      "value": "Introduce el correo electrónico y la contraseña que deseas usar."
    }
  ],
  "consumer_update_password": [
    {
      "type": 0,
      "value": "Actualizar contraseña"
    }
  ],
  "consumer_update_your_password": [
    {
      "type": 0,
      "value": "Actualiza tu contraseña"
    }
  ],
  "consumer_updating_password": [
    {
      "type": 0,
      "value": "Actualizando contraseña..."
    }
  ],
  "consumer_welcome_back": [
    {
      "type": 0,
      "value": "¡Bienvenido de nuevo!"
    }
  ],
  "error_coupon_minimum": [
    {
      "type": 0,
      "value": "No se puede aplicar el código de descuento. El total de la compra es inferior al importe mínimo requerido"
    }
  ],
  "error_coupon_not_found": [
    {
      "type": 0,
      "value": "No se encontró el código de descuento"
    }
  ],
  "error_email_invalid": [
    {
      "type": 0,
      "value": "Introduce una dirección de correo electrónico válida."
    }
  ],
  "error_email_required": [
    {
      "type": 0,
      "value": "Introduce tu dirección de correo electrónico."
    }
  ],
  "error_fields_required": [
    {
      "type": 0,
      "value": "Completa los campos a continuación."
    }
  ],
  "error_reservation_not_found": [
    {
      "type": 0,
      "value": "No se encontró la reserva."
    }
  ],
  "error_scan_band": [
    {
      "type": 0,
      "value": "No existen fotos para esta cuenta. Por favor, escanea una banda que se usó en la estación de fotos"
    }
  ],
  "error_see_attendant": [
    {
      "type": 0,
      "value": "No existen fotos para esta cuenta. Pide ayuda a un fotógrafo o asistente"
    }
  ],
  "form_label_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Tarjeta de crédito o débito"
    }
  ],
  "form_label_customers_name": [
    {
      "type": 0,
      "value": "Customer's Name"
    }
  ],
  "form_label_email": [
    {
      "type": 0,
      "value": "Correo electrónico"
    }
  ],
  "form_label_email_address": [
    {
      "type": 0,
      "value": "Dirección de correo electrónico"
    }
  ],
  "form_label_last_name": [
    {
      "type": 0,
      "value": "Apellido"
    }
  ],
  "form_label_password": [
    {
      "type": 0,
      "value": "Contraseña"
    }
  ],
  "form_label_pin": [
    {
      "type": 0,
      "value": "Pin"
    }
  ],
  "form_label_price": [
    {
      "type": 0,
      "value": "Precio (en "
    },
    {
      "type": 1,
      "value": "currency"
    }
  ],
  "form_label_room_number": [
    {
      "type": 0,
      "value": "Número de habitación"
    }
  ],
  "form_label_secret_code": [
    {
      "type": 0,
      "value": "Código secreto"
    }
  ],
  "form_label_select_all": [
    {
      "type": 0,
      "value": "Seleccionar todo"
    }
  ],
  "form_label_unlock_all": [
    {
      "type": 0,
      "value": "Ver todas las imágenes"
    }
  ],
  "kiosk_approval_form_header": [
    {
      "type": 0,
      "value": "Aprobación necesaria"
    }
  ],
  "kiosk_approval_form_instructions": [
    {
      "type": 0,
      "value": "Solicite ayuda"
    }
  ],
  "kiosk_attendant_form_header": [
    {
      "type": 0,
      "value": "Aprobar compra"
    }
  ],
  "kiosk_attendant_form_instructions": [
    {
      "type": 0,
      "value": "Introduce el precio de esta compra."
    }
  ],
  "kiosk_auto_logout_subtitle": [
    {
      "type": 0,
      "value": "Se cerrará automáticamente la sesión en "
    },
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " second"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " seconds"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "kiosk_auto_logout_title": [
    {
      "type": 0,
      "value": "¿Todavía estás ahí?"
    }
  ],
  "kiosk_cart_count_verbose": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digital image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digital images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "imageCount"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " print"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " prints"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "printCount"
    }
  ],
  "kiosk_cart_header": [
    {
      "type": 0,
      "value": "Revisar y comprar"
    }
  ],
  "kiosk_cart_instructions": [
    {
      "type": 0,
      "value": "Pulsa  "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": "para eliminar una imagen de tu carrito. Pulsa "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "FINALIZAR COMPRA "
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "para continuar."
    }
  ],
  "kiosk_catalog_header": [
    {
      "type": 0,
      "value": "Añadir Imágenes A Tu Galería"
    }
  ],
  "kiosk_catalog_header_no_gallery": [
    {
      "type": 0,
      "value": "Seleccionar Imágenes Para Comprar"
    }
  ],
  "kiosk_catalog_instructions": [
    {
      "type": 0,
      "value": "Pulsa las imágenes para agregarlas a tu galería. Pulsa "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "VER MI GALERÍA "
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "para volver a tu galería."
    }
  ],
  "kiosk_catalog_instructions_no_gallery": [
    {
      "type": 0,
      "value": "Pulsa sobre las imágenes para agregarlas a tu pedido. Pulsa "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "REVISAR Y COMPRAR "
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "para continuar."
    }
  ],
  "kiosk_catalog_loading_message": [
    {
      "type": 0,
      "value": "Cargando imágenes..."
    }
  ],
  "kiosk_edit_moment_adjust_subject": [
    {
      "type": 0,
      "value": "Adjust Subject"
    }
  ],
  "kiosk_edit_moment_apply_changes": [
    {
      "type": 0,
      "value": "Apply Changes"
    }
  ],
  "kiosk_edit_moment_apply_overlay": [
    {
      "type": 0,
      "value": "Apply Overlay"
    }
  ],
  "kiosk_edit_moment_back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "kiosk_edit_moment_close_confirmation": [
    {
      "type": 0,
      "value": "All changes you have made will be discarded. Are you sure you want to continue?"
    }
  ],
  "kiosk_edit_moment_complete_edit": [
    {
      "type": 0,
      "value": "Complete Edit"
    }
  ],
  "kiosk_edit_moment_crop_image": [
    {
      "type": 0,
      "value": "Crop Image"
    }
  ],
  "kiosk_edit_moment_done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "kiosk_edit_moment_next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "kiosk_gallery_header": [
    {
      "type": 0,
      "value": "Seleccionar y comprar"
    }
  ],
  "kiosk_gallery_header_clubmed": [
    {
      "type": 0,
      "value": "Tu galería de imágenes"
    }
  ],
  "kiosk_gallery_header_pre_print": [
    {
      "type": 0,
      "value": "Seleccionar e imprimir"
    }
  ],
  "kiosk_gallery_header_unlocked": [
    {
      "type": 0,
      "value": "Tu galería de imágenes"
    }
  ],
  "kiosk_gallery_instructions": [
    {
      "type": 0,
      "value": "Pulsa sobre la imagen para seleccionar la compra. Pulsa "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " para continuar."
    }
  ],
  "kiosk_gallery_instructions_empty_gallery": [
    {
      "type": 0,
      "value": "Tu galería está vacía. Pulsa "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "MÁS IMÁGENES "
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "en la esquina superior derecha de la pantalla para explorar las imágenes disponibles."
    }
  ],
  "kiosk_gallery_instructions_pre_print": [
    {
      "type": 0,
      "value": "Pulsa el icono de impresión de una imagen para seleccionarla e imprimirla. Pulsa el botón Imprimir para descargar las imágenes seleccionadas"
    }
  ],
  "kiosk_gallery_instructions_prints": [
    {
      "type": 0,
      "value": "Pulsa sobre la imagen para hacer tu selección de compra. Pulsa dos veces para solicitar una impresión. Pulsa "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " para continuar."
    }
  ],
  "kiosk_gallery_instructions_unlocked": [
    {
      "type": 0,
      "value": "Has desbloqueado todas las imágenes. Pulsa "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " para eliminar de tu galería."
    }
  ],
  "kiosk_gallery_instructions_unlocked_prints": [
    {
      "type": 0,
      "value": "Has desbloqueado todas las imágenes. Pulsa una imagen para solicitar una impresión. Pulsa "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " para eliminar de tu galería."
    }
  ],
  "kiosk_image_tooltip_add_print": [
    {
      "type": 0,
      "value": "Añadir impresión"
    }
  ],
  "kiosk_image_tooltip_digital_purchased": [
    {
      "type": 0,
      "value": "Digital comprada"
    }
  ],
  "kiosk_image_tooltip_print_purchased": [
    {
      "type": 0,
      "value": "Impresión comprada"
    }
  ],
  "kiosk_image_tooltip_print_selected": [
    {
      "type": 0,
      "value": "Impresión seleccionada"
    }
  ],
  "kiosk_image_tooltip_remove_print": [
    {
      "type": 0,
      "value": "Eliminar impresión"
    }
  ],
  "kiosk_image_tooltip_select_print": [
    {
      "type": 0,
      "value": "Seleccionar impresión"
    }
  ],
  "kiosk_images_header": [
    {
      "type": 0,
      "value": "Tus imágenes"
    }
  ],
  "kiosk_images_header_clubmed": [
    {
      "type": 0,
      "value": "Seleccionar imágenes"
    }
  ],
  "kiosk_images_header_selected": [
    {
      "type": 0,
      "value": "Tu selección"
    }
  ],
  "kiosk_login_header_access_your_images": [
    {
      "type": 0,
      "value": "Accede a tus imágenes"
    }
  ],
  "kiosk_login_header_clubmed": [
    {
      "type": 0,
      "value": "Introduce tu número de habitación, apellido y correo electrónico para acceder a tu galería"
    }
  ],
  "kiosk_login_header_preprint": [
    {
      "type": 0,
      "value": "Pre-Print Gallery"
    }
  ],
  "kiosk_login_header_welcome": [
    {
      "type": 0,
      "value": "¡Bienvenido!"
    }
  ],
  "kiosk_login_hpx_footer_text": [
    {
      "type": 0,
      "value": "El Mundo Mágico y todas las marcas comerciales, personajes, nombres e indicios relacionados son © & ™ Warner Bros. Entertainment Inc. Derechos de publicación © JKR. (s22)"
    }
  ],
  "kiosk_login_instructions_clubmed": [
    {
      "type": 0,
      "value": "Introduce tu número de habitación, apellido y correo electrónico para acceder a tu galería"
    }
  ],
  "kiosk_login_instructions_enter_email": [
    {
      "type": 0,
      "value": "Introduce tu dirección de correo electrónico para continuar."
    }
  ],
  "kiosk_login_instructions_scan_band": [
    {
      "type": 0,
      "value": "Escanea tu pulsera para comenzar"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_header": [
    {
      "type": 0,
      "value": "Facturar a la habitación"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_instructions": [
    {
      "type": 0,
      "value": "El total a continuación se facturará a tu habitación"
    }
  ],
  "kiosk_offsite_pos_form_generic_header": [
    {
      "type": 0,
      "value": "Finalizar compra"
    }
  ],
  "kiosk_offsite_pos_form_generic_instructions": [
    {
      "type": 0,
      "value": "Tu pedido incluye:"
    }
  ],
  "kiosk_order_details_disclaimer_no_refunds": [
    {
      "type": 0,
      "value": "* Todas las ventas son finales y no se ofrece ningún reembolso."
    }
  ],
  "kiosk_order_details_header": [
    {
      "type": 0,
      "value": "Detalles del pedido"
    }
  ],
  "kiosk_order_details_instructions": [
    {
      "type": 0,
      "value": "Pulsa las imágenes de la izquierda para realizar la selección de compra."
    }
  ],
  "kiosk_order_details_instructions_cart_empty": [
    {
      "type": 0,
      "value": "Tu carrito está vacío. Pulsa sobre las imágenes para agregarlas a tu pedido."
    }
  ],
  "kiosk_order_details_instructions_cart_empty_more_images": [
    {
      "type": 0,
      "value": "Tu carrito está vacío. Pulsa "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AGREGAR MÁS IMÁGENES"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " para agregar más imágenes"
    }
  ],
  "kiosk_order_details_instructions_email": [
    {
      "type": 0,
      "value": "Recibirás tus imágenes por correo electrónico"
    }
  ],
  "kiosk_order_details_instructions_prints": [
    {
      "type": 0,
      "value": "Pulsa dos veces la imagen para solicitar una impresión."
    }
  ],
  "kiosk_order_details_line_item_digitals": [
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digital Image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digital Images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "kiosk_order_details_line_item_prints": [
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Print"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Prints"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "kiosk_order_details_line_item_unlock_all": [
    {
      "type": 0,
      "value": "Todas las imágenes digitales"
    }
  ],
  "kiosk_order_details_line_item_unlock_all_prints": [
    {
      "type": 0,
      "value": "Todas las imágenes digitales e impresiones"
    }
  ],
  "kiosk_order_details_total": [
    {
      "type": 0,
      "value": "Total:"
    }
  ],
  "kiosk_payment_method_form_header": [
    {
      "type": 0,
      "value": "Finalizar compra"
    }
  ],
  "kiosk_payment_method_form_instructions": [
    {
      "type": 0,
      "value": "¿Cómo te gustaría completar tu compra?"
    }
  ],
  "kiosk_price_guide_header": [
    {
      "type": 0,
      "value": "Guía de precios"
    }
  ],
  "kiosk_price_guide_instructions": [
    {
      "type": 0,
      "value": "Compra más imágenes para obtener un descuento"
    }
  ],
  "kiosk_price_guide_instructions_standard_price": [
    {
      "type": 0,
      "value": "El precio estándar es "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " por imagen"
    }
  ],
  "kiosk_price_guide_instructions_unlocked": [
    {
      "type": 0,
      "value": "Puedes agregar más imágenes sin costo alguno"
    }
  ],
  "kiosk_print_size_edits_cancel": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "kiosk_print_size_edits_continue": [
    {
      "type": 0,
      "value": "Continue"
    }
  ],
  "kiosk_print_size_edits_create": [
    {
      "type": 0,
      "value": "Create"
    }
  ],
  "kiosk_print_size_select_header": [
    {
      "type": 0,
      "value": "Tamaños de impresión"
    }
  ],
  "kiosk_print_size_select_instructions": [
    {
      "type": 0,
      "value": "Seleccionar tamaño(s) de impresión y contar"
    }
  ],
  "kiosk_processing_edited_moment": [
    {
      "type": 0,
      "value": "Processing edited moment..."
    }
  ],
  "kiosk_processing_payment": [
    {
      "type": 0,
      "value": "Procesando el pago..."
    }
  ],
  "kiosk_purchase_details_discounts_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Descuentos ofrecidos:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_packages_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Paquetes ofrecidos:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_per_image": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " por imagen"
    }
  ],
  "kiosk_purchase_details_standard_price": [
    {
      "children": [
        {
          "type": 0,
          "value": "Precio estándar:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_total": [
    {
      "children": [
        {
          "type": 0,
          "value": "Total:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_disabled_instructions": [
    {
      "type": 0,
      "value": "Pulsa sobre las imágenes para agregarlas a tu pedido."
    }
  ],
  "kiosk_purchase_disabled_instructions_more_images": [
    {
      "type": 0,
      "value": "Pulsa las imágenes para seleccionarlas o deseleccionarlas para comprarlas. Para agregar más imágenes de tu selección, pulsa "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "MÁS "
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "IMÁGENES."
    }
  ],
  "kiosk_reader_not_connected": [
    {
      "type": 0,
      "value": "Lector no conectado"
    }
  ],
  "kiosk_reader_payment_failed": [
    {
      "type": 0,
      "value": "Error de procesamiento del lector"
    }
  ],
  "kiosk_reader_standby": [
    {
      "type": 0,
      "value": "El lector está en espera..."
    }
  ],
  "kiosk_receipt_header": [
    {
      "type": 0,
      "value": "Compra completa"
    }
  ],
  "kiosk_receipt_instructions": [
    {
      "type": 0,
      "value": "Se ha enviado un enlace a tu galería a "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " ."
    }
  ],
  "kiosk_remove_modal_instructions": [
    {
      "type": 0,
      "value": "¿Quieres eliminar esta imagen de tu pedido? Deberás encontrarla nuevamente tocando "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AGREGAR MÁS IMÁGENES"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_room_dialog_header": [
    {
      "type": 0,
      "value": "Habitación "
    },
    {
      "type": 1,
      "value": "room"
    }
  ],
  "kiosk_room_dialog_header_multiple": [
    {
      "type": 0,
      "value": "Habitaciones "
    },
    {
      "type": 1,
      "value": "rooms"
    }
  ],
  "kiosk_room_dialog_instructions_link_sent": [
    {
      "type": 0,
      "value": "Se ha enviado un enlace por correo electrónico a "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_selected_print_size": [
    {
      "type": 0,
      "value": "Print Size"
    }
  ],
  "kiosk_selected_print_sizes_aspect_column": [
    {
      "type": 0,
      "value": "Relación de aspecto"
    }
  ],
  "kiosk_selected_print_sizes_header": [
    {
      "type": 0,
      "value": "Impresiones seleccionadas"
    }
  ],
  "kiosk_selected_print_sizes_photo_column": [
    {
      "type": 0,
      "value": "Momento"
    }
  ],
  "kiosk_selected_print_sizes_quantity_column": [
    {
      "type": 0,
      "value": "Contar"
    }
  ],
  "kiosk_selected_print_sizes_size_column": [
    {
      "type": 0,
      "value": "Tamaño de impresión"
    }
  ],
  "kiosk_stripe_form_header": [
    {
      "type": 0,
      "value": "Finalizar compra"
    }
  ],
  "kiosk_stripe_form_header_clubmed": [
    {
      "type": 0,
      "value": "Introduce la información de pago"
    }
  ],
  "kiosk_topbar_welcome_message": [
    {
      "type": 0,
      "value": "¡Te damos la bienvenida, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "kiosk_welcome_message": [
    {
      "type": 0,
      "value": "¡Te damos la bienvenida, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ]
}